import { datadogRum } from "@datadog/browser-rum";
import meta from "./meta";
import { SessionType } from "frontend-admin/src/modules/interface";

const { datadogRUM } = meta();

export const initDatadogRUM = () => {
  datadogRum.init(datadogRUM);
};

export const startDatadogRUMReplayRecording = () => {
  datadogRum.startSessionReplayRecording();
};

export const removeDatadogRUMUser = () => {
  datadogRum.removeUser();
};

export const identifyDatadogRUMUser = (session: SessionType["session"]) => {
  const userProperties = getUserProperties(session);

  datadogRum.setUser({
    // As facility user names are not being searched for
    // we keep the facility's name instead of facility user's name for backward compatible
    name: session.profile?.name,
    email: session.user?.email,
    ...userProperties,
  });
};

export function setDatadogUserProperty(key: string, value: unknown) {
  datadogRum.setUserProperty(key, value);
}

function getUserProperties(session: SessionType["session"]) {
  if (session?.adminProfile) {
    return {
      type: "ADMIN",
      id: session.user?._id,
      sessionType: session.type,
      ...(session.type === "FACILITY"
        ? {
            facilityId: session.profile?.userId,
          }
        : {
            agentId: session.profile?.userId,
          }),
    };
  } else {
    return {
      type: "FACILITY",
      id: session.user?._id,
      facilityId: session.profile?.userId,
    };
  }
}
